
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';


import { useNavigate } from 'react-router-dom';
import React, { useState, useContext, useEffect } from 'react';

import { ArrowLeft, Sparkles, Star, Zap, Crown, Check, Shield } from 'lucide-react';
import '../../../../assets/css/screens/serviceprovider/dashboard/subscription/SubscriptionPlan.css';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';



const TIER_ICON = {
  Basic: <Zap size={18} />,
  Pro: <Star size={18} />,
  Elite: <Crown size={18} />,
};
// Tier gradient map
const TIER_CLASS = {
  Basic: 'wsp-card--starter',
  Pro: 'wsp-card--pro',
  Elite: 'wsp-card--elite',
};
const WorkerSubscription = () => {
  const navigate = useNavigate();
    const { baseUrl,authToken } = useContext(AppContext);
  const [subscription, setSubscription] = useState([]);

  // const handleSubscribe = (planId) => {
  //   // Add payment / subscription API call here
  //   console.log('Subscribe to:', planId);
  // };
  const viewsubscriptions = async() => {
     const authToken = localStorage.getItem('authToken');
        axios.get(`${baseUrl}/worker/subscriptionplan`,
          {
              headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem("authToken") || ""}`
      },
          }
        )
        .then((response) => {
          console.log(response.data);
          console.log(response.data.subscriptions[0].features);
            console.log(response.data.subscriptions);
            setSubscription(response.data.subscriptions);
          })
          .catch((error) => {
            console.log(error);
          });
  }
   useEffect(() => {
     viewsubscriptions();
  }, []);


  return (
    <>
    <WorkerNavbar/>
   
    <div className="wsp-page">

      {/* ── Back ── */}
      <button className="wsp-back" onClick={() => navigate(-1)}>
        <ArrowLeft size={16} /> Back
      </button>

      {/* ── Hero heading ── */}
      <div className="wsp-hero">
        <div className="wsp-hero__badge">
          <Sparkles size={13} /> Premium Membership
        </div>
        <h1 className="wsp-hero__title">Choose Your Plan</h1>
        <p className="wsp-hero__sub">
          Unlock premium features, get priority access, and enjoy a seamless WorkHub experience.
        </p>
      </div>

      {/* ── Plans Grid ── */}
      <div className="wsp-grid">
        {subscription.map((plan, i) => (
         <div
  key={plan.id}
  className={`wsp-card ${TIER_CLASS[plan.tier] || 'wsp-card--basic'}`}
>
            {/* Popular badge */}
            {plan.popular && (
              <div className="wsp-popular-badge">Most Popular</div>
            )}

            {/* Icon */}
<div className="wsp-card__icon">
  {TIER_ICON[plan.tier] || <Star size={18} />}
</div>
            {/* Name */}
            <h3 className="wsp-card__name">{plan.planName}</h3>

            {/* Price */}
            <div className="wsp-card__price-row">
              <span className="wsp-card__price">${plan.price}</span>
              <span className="wsp-card__period">/ {plan.duration}</span>
            </div>

            {/* Divider */}
            <div className="wsp-card__divider" />

            {/* Features */}
           <ul className="wsp-card__features">
  {(plan.features || "")
    .split(",")
    .map((f, fi) => (
      <li key={fi}>
        <span className="wsp-card__check">
          <Check size={13} />
        </span>
        {f.trim()}
      </li>
    ))}
</ul>

            {/* Subscribe button */}
            <button
              className={`wsp-card__btn${plan.popular ? ' wsp-card__btn--primary' : ''}`}
              // onClick={() => handleSubscribe(plan.id)}
            >
              Subscribe Now
            </button>
          </div>
        ))}
      </div>

      {/* ── Footer note ── */}
      <div className="wsp-footer-note">
        <Shield size={14} /> Secured payments. Cancel anytime.
      </div>

    </div>
     </>
  );
};

export default WorkerSubscription;